export enum EtaError {
  OUT_OF_RANGE = "OUT_OF_RANGE",
  INVALID_ETA = "INVALID_ETA",
  NO_ETA = "NO_ETA",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}
